import React from 'react'
import PropTypes from 'prop-types'

import { Box, Text } from '@domain-group/suit-theme'

const Description = (props) => {
  const { children } = props

  return (
    <Box display={['none', 'flex']} marginTop="small" overflow="hidden">
      <Text color="bodyFontLightColor" fontSize="xsmall" maxWidth="fit-content" variant="twoLineEllipsis">
        {children}
      </Text>
    </Box>
  )
}

Description.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Description
